import RetencionForm from './RetencionForm'
export {RetencionForm}
export default RetencionForm
